import SydDialog from 'components/Shared/SydDialog/SydDialog'
import { useCallback } from 'react'
import ErrorClose from 'assets/error-close.svg'
import {
  setDuplicatedXMLs,
  setIsDuplicatedXMLsOpen,
  setIsErrorXMLsOpen,
  setIsMoreDetailsModalOpen,
} from 'store/Invoices/invoices.reducer'
import { selectInvoicesManualXML } from 'store/Invoices/invoices.selectors'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import SydDrawer from 'components/Shared/SydDrawer/SydDrawer'
import NewCFDIErrorsDescription from 'components/Invoices/NewCFDI/NewCFDIErrorsDescription/NewCFDIErrorsDescription'

const InvoicesManualCFDIsUploadHub = () => {
  const dispatch = useAppDispatch()

  const { isDuplicatedModalOpen, isErrorModalOpen, errorXMLs, duplicatedXMLs, isMoreDetailsModalOpen } =
    useAppSelector(selectInvoicesManualXML)

  const handleCloseDuplicatedFiles = useCallback(() => {
    if (errorXMLs.length === 0) {
      dispatch(setIsDuplicatedXMLsOpen(false))
      dispatch(setDuplicatedXMLs([]))
    } else {
      dispatch(setIsDuplicatedXMLsOpen(false))
      dispatch(setIsErrorXMLsOpen(true))
    }
  }, [errorXMLs, dispatch])

  const handleCloseErrorFiles = useCallback(() => {   
    dispatch(setIsErrorXMLsOpen(false))    
  }, [dispatch])

  const handleCloseErrorDetailsDrawer = useCallback(() => {
    dispatch(setIsMoreDetailsModalOpen(false))
  }, [dispatch])
  

  return (
    <>
      <SydDialog
        open={isDuplicatedModalOpen}
        variant="warning"
        title="Archivos duplicados"
        message={`Los siguientes ${duplicatedXMLs.length} archivos ya existen en tu lista de CFDIs, por lo que no se cargarán a la plataforma.`}
        onConfirm={handleCloseDuplicatedFiles}
        onClose={handleCloseDuplicatedFiles}
        className="invoices-upload-dialog">
        {duplicatedXMLs.length > 0 && (
          <div className="invoices-manual-xml-upload-content">
            <div className="invoices-manual-xml-upload-content-list">
              {duplicatedXMLs.map(xml => (
                <span>
                  {xml.substring(xml.lastIndexOf(':') + 1, xml.length)}
                </span>
              ))}
            </div>
          </div>
        )}
      </SydDialog>

      <SydDialog
        open={isErrorModalOpen}
        variant="danger"
        title="Archivos no cargados"
        message={`Algo salió mal y no fue posible cargar los siguientes ${errorXMLs.length} archivos:`}
        onClose={handleCloseDuplicatedFiles}
        onConfirm={handleCloseErrorFiles}
        className="invoices-upload-dialog"
        icon={ErrorClose}>
        {errorXMLs.length > 0 && (
          <div className="invoices-manual-xml-upload-content">
            <div className="invoices-manual-xml-upload-content-list">
              {errorXMLs.map(errXml => (
                <span>
                  {errXml.substring(errXml.lastIndexOf(':') + 1, errXml.length)}
                </span>
              ))}
            </div>
          </div>
        )}
      </SydDialog>

      <SydDrawer
        isOpen={isMoreDetailsModalOpen}
        handleClose={handleCloseErrorDetailsDrawer}
        title="Archivos cargados"
      >
        <NewCFDIErrorsDescription
          errors={errorXMLs}
          duplicated={duplicatedXMLs}
        />
      </SydDrawer>
    </>
  )
}

export default InvoicesManualCFDIsUploadHub
